import Header from './Header';
import Footer from './Footer';
import { Toaster } from 'sonner';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-richblack">
      <Header />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <Footer />
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0F0F0F',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            color: '#F5F5F5',
          },
        }}
      />
    </div>
  );
};

export default Layout;
